(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social_feed"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.carousel-wrapper');

    containers.forEach(wrapper => {
      const trackContainer = wrapper.querySelector('.carousel-track-container');
      // If no track container (static mode), exit
      if (!trackContainer) return;

      const track = wrapper.querySelector('.carousel-track');
      const cards = wrapper.querySelectorAll('.media-card');
      const prevBtn = wrapper.querySelector('.nav-prev');
      const nextBtn = wrapper.querySelector('.nav-next');
      
      let isPaused = false;
      let scrollAmount = 0;
      const cardWidth = 300; // Card + Gap approx
      const speed = 1; // Speed of auto scroll

      // 1. Auto Scroll Functionality
      function autoScroll() {
        if (!isPaused) {
          trackContainer.scrollLeft += speed;
          
          // Infinite Loop Logic: If we reach end, snap back (simplistic loop)
          // For true infinite, we usually clone nodes, but for this snippet we loop scroll
          if (trackContainer.scrollLeft >= (trackContainer.scrollWidth - trackContainer.clientWidth)) {
             trackContainer.scrollLeft = 0;
          }
        }
        requestAnimationFrame(autoScroll);
      }

      // Start Auto Scroll only if content overflows
      if (trackContainer.scrollWidth > trackContainer.clientWidth) {
         requestAnimationFrame(autoScroll);
      }

      // 2. Pause on Hover
      wrapper.addEventListener('mouseenter', () => isPaused = true);
      wrapper.addEventListener('mouseleave', () => isPaused = false);

      // 3. Navigation Buttons
      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', () => {
          trackContainer.scrollBy({ left: -cardWidth, behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', () => {
          trackContainer.scrollBy({ left: cardWidth, behavior: 'smooth' });
        });
      }

      // 4. Highlight Center Card (Focus State)
      trackContainer.addEventListener('scroll', () => {
        const centerPoint = trackContainer.scrollLeft + (trackContainer.clientWidth / 2);
        
        cards.forEach(card => {
          const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
          // If card center is within 100px of viewport center
          if (Math.abs(centerPoint - cardCenter) < 140) {
            card.classList.add('active-card');
          } else {
            card.classList.remove('active-card');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
